export default __webpack_public_path__ + "static/media/large_camper_wide.76a7d600.jpeg";